import styled from 'styled-components/macro';

export const OkeyBtn = styled.button`
  width: 265px;
  height: 52px;
  background: #00B595;
  border-radius: 22px;
  cursor: pointer;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 25px auto 0;

  font-size: 16px;
  font-family: Squad-Bold, Squad;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 21px;

    &:disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    &:active {
      transform: scale(0.95);
    }
`;
